import { DEMO_API_PREFIX } from "@demo/constants/routing";
import type { ReportPayload } from "@demo/server/api/contracts/report";

export interface SubmitReportResult {
  ok: true;
  partial: boolean;
  failed: string[];
}

export interface SubmitReportArgs {
  payload: ReportPayload;
  screenshot: Blob | null;
}

/**
 * Submits a feedback report to the server. Returns the server's result on
 * success and throws on network/HTTP failures so the caller can surface it.
 *
 * Uses native fetch (not ky) because the request is multipart/form-data and
 * we need direct control over the body.
 */
export const submitReport = async (args: SubmitReportArgs): Promise<SubmitReportResult> => {
  const formData = new FormData();
  formData.append("payload", JSON.stringify(args.payload));
  if (args.screenshot) {
    formData.append("screenshot", args.screenshot, "screenshot.png");
  }

  const res = await fetch(`${DEMO_API_PREFIX}/rest/report`, { method: "POST", body: formData });
  const json = await res.json();
  if (!res.ok) {
    throw new Error(json.error || `report_failed_${res.status}`);
  }
  return json as SubmitReportResult;
};
